import { Link } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

const hotKeywords = ["淘宝", "微博", "知乎", "哔哩哔哩", "GitHub", "翻译工具", "在线课程"];

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-primary-900">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20digital%20network%20background%20with%20deep%20navy%20blue%20gradient%2C%20soft%20glowing%20connected%20nodes%20and%20lines%2C%20minimal%20modern%20clean%20technology%20texture%2C%20no%20text%2C%20high%20detail&width=1920&height=800&seq=nav-hero-01&orientation=landscape"
          alt="网址导航背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-900/75 to-primary-950/85"></div>
      </div>

      <div className="relative mx-auto max-w-[1280px] px-4 py-16 text-center md:px-6 md:py-24">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-400/40 bg-primary-800/50 px-3 py-1 text-xs font-medium text-primary-100">
          <i className="ri-fire-line text-accent-400"></i>
          已收录 40+ 精选网站 · 10 大热门分类
        </span>
        <h1 className="mt-5 text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          快速访问热门网站的入口
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
          网址导航为你精选最新最全的热门网站，分类清晰、一键直达，让查找资源和常用平台变得高效简单。
        </p>

        <div className="mx-auto mt-8 w-full max-w-2xl">
          <SearchBar size="lg" placeholder="输入网站名称、分类或关键词，如：淘宝、翻译工具" />
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-primary-200">热门搜索：</span>
          {hotKeywords.map((kw) => (
            <Link
              key={kw}
              to={`/search?q=${encodeURIComponent(kw)}`}
              className="rounded-full border border-primary-400/30 bg-primary-800/40 px-3 py-1 text-xs text-primary-100 transition-colors hover:border-accent-400/60 hover:text-accent-200"
            >
              {kw}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}